import './ccf-toggle-icon-button.module.scss';
import { IconButton, IconButtonProps } from '@mui/material';
import React from 'react';
/* eslint-disable-next-line */
export interface CCfToggleIconButtonProps extends IconButtonProps {
  icon: React.ReactNode;
  toggleIcon: React.ReactNode;
  onClick?: () => void;
  isToggled?: boolean;
}

/**
 * Display toggle icon buttons
 * @param props - CCfToggleIconButtonProps
 * @example <CCfToggleIconButton />
 * @returns 
 */
export function CCfToggleIconButton(props: CCfToggleIconButtonProps) {
  const { icon, toggleIcon, isToggled = false, onClick, ...rest } = props;
  const [toggle, updateToggle] = React.useState(isToggled);

  /**
   * Function to handle when toggle icon button click
   * @param e - React.MouseEvent,
   * @example onToggleIconButtonClick(e)
   */
  function onToggleIconButtonClick(e: React.MouseEvent<HTMLButtonElement, MouseEvent>){
    e.stopPropagation();
    updateToggle(!toggle);
    if(onClick) onClick();
  }

  return (
    <IconButton onClick={ e => onToggleIconButtonClick(e) } {...rest} >
      {toggle ? icon : toggleIcon}
    </IconButton>
  )
}

export default CCfToggleIconButton;
